@if (listBookedData.objects.length > 0) {
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-sm-12" formArrayName="groups">
        <h3>Abgeschlossene Positionen</h3>
        @for (group of formArrayMapped; track trackByBookedFn(iG, group); let iG = $index) {
          <material-order-intake-booked-group [group]="group"
            [indexG]="iG"
            [groups]="groups"
            [markedVariationId]="markedVariationId"
            [markedTransactionId]="markedTransactionId"
            [finderSupplierUri]="finderSupplierUri"
            [form]="group.form"
            [errors]="errors"
            (updateOrder)="updateView()"
            >
          </material-order-intake-booked-group>
        }
      </div>
    </div>
    @if (('material.order.price.check'|HasPerm)) {
      <div class="row">
        <div class="col-sm-12 align-right">
          <button type="submit" class="btn btn-success" [disabled]="form.valid && submitLocked">
            Preise festlegen
          </button>
        </div>
      </div>
    }
  </form>
}
